var index = {
    data() {
        return {
            id: 0,
            name: '',
            phone: '',
            communityCode: '',
            communityName: '',
            address: '',
            isDefault: 1
        }
    },
    fetch() {
        if (parseInt(this.id)) {
            this.$api.useraddress.getedit({
                id: this.id
            }).then((res) => {
                if (res.R) {
                    var data = res.data;
                    this.name = data.linkName;
                    this.phone = data.linkPhone;
                    this.communityCode = data.communityCode;
                    this.communityName = data.communityName;
                    this.address = data.address;
                    this.isDefault = data.isDefault === 1;
                }
            })
        }
    }
}

export default index;